import { render, staticRenderFns } from "./Casethai.vue?vue&type=template&id=87351700&scoped=true&"
import script from "./Casethai.vue?vue&type=script&lang=js&"
export * from "./Casethai.vue?vue&type=script&lang=js&"
import style0 from "./Casethai.vue?vue&type=style&index=0&id=87351700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87351700",
  null
  
)

export default component.exports